"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[6696],{

/***/ 45340:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ shipping_useAddressDetails)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/apollo-client/hooks/useLazyQuery.ts + 1 modules
var useLazyQuery = __webpack_require__(67851);
;// CONCATENATED MODULE: ./src/modules/user/shipping/graph/addressDetails.graphql.ts
const AddressDetailsDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "AddressDetails"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "input"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "AddressAutocompleteDetailsInput"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "addressAutocompleteDetails"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "input"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "input"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "data"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "city"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "region"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "postalCode"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "street1"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "street2"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
// remove fragments duplicates
// @ts-ignore
AddressDetailsDocument["definitions"] = [
    ...new Set(AddressDetailsDocument.definitions)
];
/* harmony default export */ const addressDetails_graphql = (AddressDetailsDocument);

;// CONCATENATED MODULE: ./src/modules/user/shipping/useAddressDetails.ts



const useAddressDetails = ()=>{
    const [getAutocompleteDetails, { data }] = (0,useLazyQuery/* default */.Z)(addressDetails_graphql);
    const autocompleteDetails = (0,react.useMemo)(()=>{
        var _data_addressAutocompleteDetails;
        return data === null || data === void 0 ? void 0 : (_data_addressAutocompleteDetails = data.addressAutocompleteDetails) === null || _data_addressAutocompleteDetails === void 0 ? void 0 : _data_addressAutocompleteDetails.data;
    }, [
        data
    ]);
    return {
        autocompleteDetails,
        getAutocompleteDetails
    };
};
/* harmony default export */ const shipping_useAddressDetails = (useAddressDetails);


/***/ }),

/***/ 36590:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ shipping_useAddressSuggestions)
});

// EXTERNAL MODULE: ./local_modules/apollo-client/hooks/useLazyQuery.ts + 1 modules
var useLazyQuery = __webpack_require__(67851);
;// CONCATENATED MODULE: ./src/modules/user/shipping/graph/addressAutocomplete.graphql.ts
const AddressAutocompleteDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "AddressAutocomplete"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "input"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "AddressAutocompleteInput"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "addressAutocomplete"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "input"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "input"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "data"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "type"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "placeId"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "mainText"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "highlight"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "secondaryText"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
// remove fragments duplicates
// @ts-ignore
AddressAutocompleteDocument["definitions"] = [
    ...new Set(AddressAutocompleteDocument.definitions)
];
/* harmony default export */ const addressAutocomplete_graphql = (AddressAutocompleteDocument);

;// CONCATENATED MODULE: ./src/modules/user/shipping/useAddressSuggestions.ts


const useAddressSuggestions = ()=>{
    var _data_addressAutocomplete;
    const [getAddressSuggestions, { data, isFetching }] = (0,useLazyQuery/* default */.Z)(addressAutocomplete_graphql);
    const addressSuggestions = data === null || data === void 0 ? void 0 : (_data_addressAutocomplete = data.addressAutocomplete) === null || _data_addressAutocomplete === void 0 ? void 0 : _data_addressAutocomplete.data;
    return {
        isFetching,
        addressSuggestions,
        getAddressSuggestions
    };
};
/* harmony default export */ const shipping_useAddressSuggestions = (useAddressSuggestions);


/***/ }),

/***/ 96340:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83305);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63687);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64667);
/* harmony import */ var modals__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39977);




const openCotyModal = (props)=>new Promise((resolve, reject)=>{
        const { oneClickPurchase, products, onFinalizeOrder } = props;
        (0,modals__WEBPACK_IMPORTED_MODULE_1__/* .openModal */ .h7)("cotyModal", {
            oneClickPurchase,
            products,
            onFinalizeOrder: ()=>{
                if (typeof onFinalizeOrder === "function") {
                    onFinalizeOrder();
                }
                resolve(true);
            },
            onClose: ()=>{
                reject(new helpers__WEBPACK_IMPORTED_MODULE_2__/* .ValidationError */ .p8(null, "Coty products can't be delivered"));
            }
        });
    });
const useCotyAddressValidation = ()=>{
    const isCotyEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z.features.cotyNYNJ);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async (param)=>{
        let { oneClickPurchase, products } = param;
        if (isCotyEnabled) {
            return openCotyModal({
                oneClickPurchase,
                products
            });
        }
    }, [
        isCotyEnabled
    ]);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useCotyAddressValidation);


/***/ }),

/***/ 99084:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ shipping_useCountryList)
});

// EXTERNAL MODULE: ./local_modules/apollo-client/hooks/useQuery.ts
var useQuery = __webpack_require__(11396);
;// CONCATENATED MODULE: ./src/modules/user/shipping/graph/countryList.graphql.ts
const CountryListDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "CountryList"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "withRegions"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "Boolean"
                        }
                    },
                    "defaultValue": {
                        "kind": "BooleanValue",
                        "value": true
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "countryList"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "data"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "id"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "alpha2"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "name"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "shippingPrice"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "regions"
                                                },
                                                "directives": [
                                                    {
                                                        "kind": "Directive",
                                                        "name": {
                                                            "kind": "Name",
                                                            "value": "include"
                                                        },
                                                        "arguments": [
                                                            {
                                                                "kind": "Argument",
                                                                "name": {
                                                                    "kind": "Name",
                                                                    "value": "if"
                                                                },
                                                                "value": {
                                                                    "kind": "Variable",
                                                                    "name": {
                                                                        "kind": "Name",
                                                                        "value": "withRegions"
                                                                    }
                                                                }
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "name"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "alpha2"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
// remove fragments duplicates
// @ts-ignore
CountryListDocument["definitions"] = [
    ...new Set(CountryListDocument.definitions)
];
/* harmony default export */ const countryList_graphql = (CountryListDocument);

;// CONCATENATED MODULE: ./src/modules/user/shipping/useCountryList.ts


const useCountryList = function() {
    let { withRegions = true, skip = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _data_countryList;
    const { data, isFetching } = (0,useQuery/* default */.Z)(countryList_graphql, {
        fetchPolicy: "cache-first",
        variables: {
            withRegions
        },
        skip
    });
    return {
        countryList: data === null || data === void 0 ? void 0 : (_data_countryList = data.countryList) === null || _data_countryList === void 0 ? void 0 : _data_countryList.data,
        isFetching
    };
};
/* harmony default export */ const shipping_useCountryList = (useCountryList);


/***/ }),

/***/ 57247:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ shipping_useShippingAddressAdd)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/apollo-client/hooks/useMutation.ts + 1 modules
var useMutation = __webpack_require__(4578);
// EXTERNAL MODULE: ./src/helpers/errors/index.ts
var errors = __webpack_require__(83305);
;// CONCATENATED MODULE: ./src/modules/user/shipping/graph/addressAdd.graphql.ts
const AddressAddDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "AddressAdd"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "input"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "AddressAddInput"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "addressAdd"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "input"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "input"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "data"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "personalInfo"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "addressInfo"
                                                            },
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "shipping"
                                                                        },
                                                                        "selectionSet": {
                                                                            "kind": "SelectionSet",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "FragmentSpread",
                                                                                    "name": {
                                                                                        "kind": "Name",
                                                                                        "value": "Address"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "shippingAddresses"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "Address"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "error"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "SecurityError"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "alias": {
                                                                "kind": "Name",
                                                                "value": "securityErrorCode"
                                                            },
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "errorCode"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "ServerError"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "alias": {
                                                                "kind": "Name",
                                                                "value": "serverErrorCode"
                                                            },
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "errorCode"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "AddressError"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "alias": {
                                                                "kind": "Name",
                                                                "value": "addressErrorCode"
                                                            },
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "errorCode"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "Address"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Address"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "primary"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "firstName"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "lastName"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "country"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "city"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "region"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "postalCode"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "street1"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "street2"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "phone"
                        }
                    }
                ]
            }
        }
    ]
};
// remove fragments duplicates
// @ts-ignore
AddressAddDocument["definitions"] = [
    ...new Set(AddressAddDocument.definitions)
];
/* harmony default export */ const addressAdd_graphql = (AddressAddDocument);

;// CONCATENATED MODULE: ./src/modules/user/shipping/useShippingAddressAdd.ts




const useShippingAddressAdd = ()=>{
    const [mutate, { isFetching, client }] = (0,useMutation/* default */.Z)(addressAdd_graphql);
    const submit = (0,react.useCallback)(async (input)=>{
        const result = await mutate({
            variables: {
                input
            }
        });
        if (result.errors) {
            throw new errors/* GraphQLError */.__(result.errors);
        }
        const { data, error } = result.data.addressAdd;
        if (error) {
            throw new errors/* UserError */.gK(error);
        }
        // cart depends on shipping address
        client.cache.evict({
            id: "UserData:{}",
            fieldName: "cart"
        });
        return data;
    }, [
        mutate,
        client
    ]);
    return [
        submit,
        {
            isFetching
        }
    ];
};
/* harmony default export */ const shipping_useShippingAddressAdd = (useShippingAddressAdd);


/***/ }),

/***/ 11848:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ shipping_useShippingAddressDelete)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/apollo-client/hooks/useMutation.ts + 1 modules
var useMutation = __webpack_require__(4578);
// EXTERNAL MODULE: ./src/helpers/errors/index.ts
var errors = __webpack_require__(83305);
;// CONCATENATED MODULE: ./src/modules/user/shipping/graph/addressDelete.graphql.ts
const AddressDeleteDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "AddressDelete"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "input"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "AddressDeleteInput"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "addressDelete"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "input"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "input"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "data"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "personalInfo"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "addressInfo"
                                                            },
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "shipping"
                                                                        },
                                                                        "selectionSet": {
                                                                            "kind": "SelectionSet",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "FragmentSpread",
                                                                                    "name": {
                                                                                        "kind": "Name",
                                                                                        "value": "Address"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "shippingAddresses"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "Address"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "error"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "SecurityError"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "alias": {
                                                                "kind": "Name",
                                                                "value": "securityErrorCode"
                                                            },
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "errorCode"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "ServerError"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "alias": {
                                                                "kind": "Name",
                                                                "value": "serverErrorCode"
                                                            },
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "errorCode"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "AddressError"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "alias": {
                                                                "kind": "Name",
                                                                "value": "addressErrorCode"
                                                            },
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "errorCode"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "ValidationError"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "alias": {
                                                                "kind": "Name",
                                                                "value": "validationErrorCode"
                                                            },
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "errorCode"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "Address"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Address"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "primary"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "firstName"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "lastName"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "country"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "city"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "region"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "postalCode"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "street1"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "street2"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "phone"
                        }
                    }
                ]
            }
        }
    ]
};
// remove fragments duplicates
// @ts-ignore
AddressDeleteDocument["definitions"] = [
    ...new Set(AddressDeleteDocument.definitions)
];
/* harmony default export */ const addressDelete_graphql = (AddressDeleteDocument);

;// CONCATENATED MODULE: ./src/modules/user/shipping/useShippingAddressDelete.ts




const useShippingAddressDelete = ()=>{
    const [mutate, { isFetching, client }] = (0,useMutation/* default */.Z)(addressDelete_graphql);
    const submit = (0,react.useCallback)(async (input)=>{
        const result = await mutate({
            variables: {
                input
            }
        });
        if (result.errors) {
            throw new errors/* GraphQLError */.__(result.errors);
        }
        const { data, error } = result.data.addressDelete;
        if (error) {
            throw new errors/* UserError */.gK(error);
        }
        // cart depends on shipping address
        client.cache.evict({
            id: "UserData:{}",
            fieldName: "cart"
        });
        return data;
    }, [
        mutate,
        client
    ]);
    return [
        submit,
        {
            isFetching
        }
    ];
};
/* harmony default export */ const shipping_useShippingAddressDelete = (useShippingAddressDelete);


/***/ }),

/***/ 61933:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ shipping_useShippingAddressUpdate)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/apollo-client/hooks/useMutation.ts + 1 modules
var useMutation = __webpack_require__(4578);
// EXTERNAL MODULE: ./src/helpers/errors/index.ts
var errors = __webpack_require__(83305);
;// CONCATENATED MODULE: ./src/modules/user/shipping/graph/addressUpdate.graphql.ts
const AddressUpdateDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "AddressUpdate"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "input"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "AddressUpdateInput"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "addressUpdate"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "input"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "input"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "data"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "personalInfo"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "addressInfo"
                                                            },
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "shipping"
                                                                        },
                                                                        "selectionSet": {
                                                                            "kind": "SelectionSet",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "FragmentSpread",
                                                                                    "name": {
                                                                                        "kind": "Name",
                                                                                        "value": "Address"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "shippingAddresses"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "Address"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "error"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "SecurityError"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "alias": {
                                                                "kind": "Name",
                                                                "value": "securityErrorCode"
                                                            },
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "errorCode"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "ServerError"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "alias": {
                                                                "kind": "Name",
                                                                "value": "serverErrorCode"
                                                            },
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "errorCode"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "AddressError"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "alias": {
                                                                "kind": "Name",
                                                                "value": "addressErrorCode"
                                                            },
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "errorCode"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "ValidationError"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "alias": {
                                                                "kind": "Name",
                                                                "value": "validationErrorCode"
                                                            },
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "errorCode"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "Address"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Address"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "primary"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "firstName"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "lastName"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "country"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "city"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "region"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "postalCode"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "street1"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "street2"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "phone"
                        }
                    }
                ]
            }
        }
    ]
};
// remove fragments duplicates
// @ts-ignore
AddressUpdateDocument["definitions"] = [
    ...new Set(AddressUpdateDocument.definitions)
];
/* harmony default export */ const addressUpdate_graphql = (AddressUpdateDocument);

;// CONCATENATED MODULE: ./src/modules/user/shipping/useShippingAddressUpdate.ts




const useShippingAddressUpdate = ()=>{
    const [mutate, { isFetching, client }] = (0,useMutation/* default */.Z)(addressUpdate_graphql);
    const submit = (0,react.useCallback)(async (input)=>{
        const result = await mutate({
            variables: {
                input
            }
        });
        if (result.errors) {
            throw new errors/* GraphQLError */.__(result.errors);
        }
        const { data, error } = result.data.addressUpdate;
        if (error) {
            throw new errors/* UserError */.gK(error);
        }
        // cart depends on shipping address
        client.cache.evict({
            id: "UserData:{}",
            fieldName: "cart"
        });
        return data;
    }, [
        mutate,
        client
    ]);
    return [
        submit,
        {
            isFetching
        }
    ];
};
/* harmony default export */ const shipping_useShippingAddressUpdate = (useShippingAddressUpdate);


/***/ }),

/***/ 81481:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ shipping_useShippingAddressValidateAndVerify)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/modals/manager.ts
var manager = __webpack_require__(39977);
// EXTERNAL MODULE: ./src/helpers/errors/index.ts
var errors = __webpack_require__(83305);
// EXTERNAL MODULE: ./local_modules/logger/index.ts
var logger = __webpack_require__(53297);
// EXTERNAL MODULE: ./local_modules/apollo-client/hooks/useApolloClients.tsx
var useApolloClients = __webpack_require__(60440);
;// CONCATENATED MODULE: ./src/modules/user/shipping/graph/addressValidateNew.graphql.ts
const AddressValidateDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "AddressValidate"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "inputNew"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "AddressValidateInput"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "addressValidate"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "inputNew"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "inputNew"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "data"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "address"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "Address"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "isPrimaryAddress"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "error"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "ValidationError"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "alias": {
                                                                "kind": "Name",
                                                                "value": "validationErrorCode"
                                                            },
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "errorCode"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "AddressValidationError"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "alias": {
                                                                "kind": "Name",
                                                                "value": "addressValidationErrorCode"
                                                            },
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "errorCode"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "SecurityError"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "alias": {
                                                                "kind": "Name",
                                                                "value": "securityErrorCode"
                                                            },
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "errorCode"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "ServerError"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "alias": {
                                                                "kind": "Name",
                                                                "value": "serverErrorCode"
                                                            },
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "errorCode"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "AmbiguousAddressError"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "message"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "suggestions"
                                                            },
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "FragmentSpread",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "Address"
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "Address"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Address"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "primary"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "firstName"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "lastName"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "country"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "city"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "region"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "postalCode"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "street1"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "street2"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "phone"
                        }
                    }
                ]
            }
        }
    ]
};
// remove fragments duplicates
// @ts-ignore
AddressValidateDocument["definitions"] = [
    ...new Set(AddressValidateDocument.definitions)
];
/* harmony default export */ const addressValidateNew_graphql = (AddressValidateDocument);

;// CONCATENATED MODULE: ./src/modules/user/shipping/useShippingAddressValidate.ts





const useShippingAddressValidateNew = ()=>{
    const apolloClient = (0,useApolloClients/* useApolloClient */.x)();
    return (0,react.useCallback)(async (enteredValues)=>{
        const { data } = await apolloClient.mutate({
            mutation: addressValidateNew_graphql,
            variables: {
                inputNew: {
                    address: {
                        firstName: enteredValues.firstName,
                        lastName: enteredValues.lastName,
                        country: enteredValues.country,
                        city: enteredValues.city,
                        region: enteredValues.region,
                        postalCode: enteredValues.postalCode,
                        street1: enteredValues.street1,
                        street2: enteredValues.street2,
                        phone: enteredValues.phone
                    },
                    apiVersion: "V2"
                }
            },
            fetchPolicy: "no-cache"
        });
        const { error } = data.addressValidate;
        logger/* default */.Z.info({
            response: data.addressValidate
        }, `[Address validation] address is ${!error ? "valid" : "invalid"}`);
        // TODO: Implement AmbiguousAddressError suggestion when loqate starts to give valid results
        // Address is not found, but we give opportunity to confirm the address manually
        if ((error === null || error === void 0 ? void 0 : error.__typename) === "AddressValidationError" && (error === null || error === void 0 ? void 0 : error.addressValidationErrorCode) === "ADDRESS_NOT_FOUND") {
            return {
                isValid: false
            };
        }
        // address error (not found)
        if ((error === null || error === void 0 ? void 0 : error.__typename) === "AddressValidationError") {
            throw new errors/* UserError */.gK(error);
        }
        // server error
        if (error) {
            throw new errors/* ServerError */.nl(error, "Address validation error");
        }
        // address is correct and validated
        const { data: { address, isPrimaryAddress } } = data.addressValidate;
        return {
            isPrimaryAddress,
            isValid: true,
            // we do this to remove all extra attributes from the response too
            recommendedValues: {
                firstName: enteredValues.firstName,
                lastName: enteredValues.lastName,
                country: address.country,
                city: address.city,
                region: address.region,
                postalCode: address.postalCode,
                street1: address.street1,
                street2: address.street2 || enteredValues.street2,
                phone: enteredValues.phone
            }
        };
    }, [
        apolloClient
    ]);
};
/* harmony default export */ const useShippingAddressValidate = (useShippingAddressValidateNew);

;// CONCATENATED MODULE: ./src/modules/user/shipping/useShippingAddressValidateAndVerify.ts




const openAddressVerificationModal = (props)=>new Promise((resolve, reject)=>{
        const { enteredValues, recommendedValues, onChoose } = props;
        (0,manager/* openModal */.h7)("addressVerificationModal", {
            enteredValues,
            recommendedValues,
            onChoose: (result)=>{
                if (typeof onChoose === "function") {
                    onChoose(result);
                }
                resolve(result);
            },
            onClose: ()=>{
                reject(new errors/* ValidationError */.p8(null, "No address was selected"));
            }
        });
    });
// validates and asks user about recommended values if needed
const useShippingAddressValidateAndVerify = ()=>{
    const validateShippingAddress = useShippingAddressValidate();
    (0,react.useEffect)(()=>{
        void (0,manager/* preloadModal */.My)("verifyShippingAddressModal");
    }, []);
    return (0,react.useCallback)(async (enteredValues)=>{
        let validatedAddressValues = enteredValues;
        let validationType = "without validation popup";
        let { isValid, recommendedValues } = await validateShippingAddress(enteredValues);
        if (!isValid) {
            const { selectedValues, selectedType } = await openAddressVerificationModal({
                enteredValues,
                recommendedValues
            });
            validatedAddressValues = selectedValues;
            validationType = selectedType;
        } else if (recommendedValues) {
            validatedAddressValues = recommendedValues;
            validationType = "automatically validated";
        }
        return {
            // to keep entered custom values
            validatedAddressValues: {
                ...enteredValues,
                ...validatedAddressValues
            },
            validationType
        };
    }, [
        validateShippingAddress
    ]);
};
/* harmony default export */ const shipping_useShippingAddressValidateAndVerify = (useShippingAddressValidateAndVerify);


/***/ }),

/***/ 1142:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ shipping_useShippingAddresses)
});

// EXTERNAL MODULE: ./local_modules/apollo-client/hooks/useQuery.ts
var useQuery = __webpack_require__(11396);
;// CONCATENATED MODULE: ./src/modules/user/shipping/graph/shippingAddresses.graphql.ts
const ShippingAddressesDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "ShippingAddresses"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currentUser"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "data"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "shippingAddresses"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "Address"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "Address"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "Address"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "primary"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "firstName"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "lastName"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "country"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "city"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "region"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "postalCode"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "street1"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "street2"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "phone"
                        }
                    }
                ]
            }
        }
    ]
};
// remove fragments duplicates
// @ts-ignore
ShippingAddressesDocument["definitions"] = [
    ...new Set(ShippingAddressesDocument.definitions)
];
/* harmony default export */ const shippingAddresses_graphql = (ShippingAddressesDocument);

;// CONCATENATED MODULE: ./src/modules/user/shipping/useShippingAddresses.ts


// returns all saved shipping addresses, if you need the current one use addressInfo from the user
const useShippingAddresses = ()=>{
    var _data_currentUser_data, _data_currentUser;
    const { data, isFetching, error } = (0,useQuery/* default */.Z)(shippingAddresses_graphql, {
        fetchPolicy: "cache-first",
        ssr: false
    });
    const shippingAddresses = data === null || data === void 0 ? void 0 : (_data_currentUser = data.currentUser) === null || _data_currentUser === void 0 ? void 0 : (_data_currentUser_data = _data_currentUser.data) === null || _data_currentUser_data === void 0 ? void 0 : _data_currentUser_data.shippingAddresses;
    return {
        shippingAddresses,
        primaryShippingAddress: shippingAddresses === null || shippingAddresses === void 0 ? void 0 : shippingAddresses.find((param)=>{
            let { primary } = param;
            return primary;
        }),
        isFetching,
        error
    };
};
/* harmony default export */ const shipping_useShippingAddresses = (useShippingAddresses);


/***/ }),

/***/ 81205:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var formular__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6938);
/* harmony import */ var local_storage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71106);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63687);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64667);
/* harmony import */ var helpers_validators__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4894);






const getPostalCodeValidators = (country)=>{
    if (!country || country === "US") {
        return [
            helpers_validators__WEBPACK_IMPORTED_MODULE_1__/* .required */ .C1,
            helpers_validators__WEBPACK_IMPORTED_MODULE_1__/* .zipCode */ .v0,
            helpers_validators__WEBPACK_IMPORTED_MODULE_1__/* .nonMilitaryZipCode */ .lX
        ];
    }
    return [
        helpers_validators__WEBPACK_IMPORTED_MODULE_1__/* .required */ .C1,
        helpers_validators__WEBPACK_IMPORTED_MODULE_1__/* .canadaPostalCode */ .gb
    ];
};
const useShippingForm = function() {
    let { initialValues, useLocalStorage = true } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    // to keep it unchanged
    const initialValuesRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(initialValues);
    const isAttentivePhonePermissionsEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.features.attentiveCollectPhoneNumber);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        const initialValuesFromLocalStorage =  true && useLocalStorage ? local_storage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z.getItem(helpers__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.localStorageNames.shippingFormValues) : null;
        const initialValues = initialValuesRef.current || initialValuesFromLocalStorage || {};
        // we apply zip code for the USA and postal code for other countries
        const shippingForm = new formular__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z({
            fields: {
                firstName: [
                    helpers_validators__WEBPACK_IMPORTED_MODULE_1__/* .required */ .C1,
                    helpers_validators__WEBPACK_IMPORTED_MODULE_1__/* .userName */ .RX,
                    (0,helpers_validators__WEBPACK_IMPORTED_MODULE_1__/* .maxLength */ .BS)(100)
                ],
                lastName: [
                    helpers_validators__WEBPACK_IMPORTED_MODULE_1__/* .required */ .C1,
                    helpers_validators__WEBPACK_IMPORTED_MODULE_1__/* .userName */ .RX,
                    (0,helpers_validators__WEBPACK_IMPORTED_MODULE_1__/* .maxLength */ .BS)(100)
                ],
                street1: [
                    helpers_validators__WEBPACK_IMPORTED_MODULE_1__/* .required */ .C1,
                    helpers_validators__WEBPACK_IMPORTED_MODULE_1__/* .streetAddress */ .aX
                ],
                street2: [],
                postalCode: getPostalCodeValidators(initialValues === null || initialValues === void 0 ? void 0 : initialValues.country),
                city: [
                    helpers_validators__WEBPACK_IMPORTED_MODULE_1__/* .required */ .C1,
                    (0,helpers_validators__WEBPACK_IMPORTED_MODULE_1__/* .minLength */ .Ei)(3)
                ],
                region: [
                    helpers_validators__WEBPACK_IMPORTED_MODULE_1__/* .required */ .C1,
                    helpers_validators__WEBPACK_IMPORTED_MODULE_1__/* .nonMilitaryState */ .ZW
                ],
                country: {
                    validate: [
                        helpers_validators__WEBPACK_IMPORTED_MODULE_1__/* .required */ .C1
                    ],
                    value: "US"
                },
                phone: [
                    helpers_validators__WEBPACK_IMPORTED_MODULE_1__/* .phone */ .m7,
                    (0,helpers_validators__WEBPACK_IMPORTED_MODULE_1__/* .when */ .gx)((values)=>values.receiveAlertsByPhone || values.receiveOffersByPhone, [
                        helpers_validators__WEBPACK_IMPORTED_MODULE_1__/* .required */ .C1
                    ])
                ],
                receiveAlertsByPhone: [],
                receiveOffersByPhone: []
            },
            getValues: (values)=>{
                const additionalFields = {
                    receiveAlertsByPhone: isAttentivePhonePermissionsEnabled && Boolean(values.receiveAlertsByPhone),
                    receiveOffersByPhone: isAttentivePhonePermissionsEnabled && Boolean(values.receiveOffersByPhone)
                };
                // we add to values only true values for better tests support
                Object.keys(additionalFields).forEach((key)=>{
                    if (additionalFields[key]) {
                        values[key] = additionalFields[key];
                    } else {
                        delete values[key];
                    }
                });
                return values;
            },
            initialValues
        });
        // ATTN we should do it only on client side
        if (true) {
            let lastCountryValue = initialValues.country || "US";
            // change postal code validators based when user selects a country
            shippingForm.fields.country.on("change", (newCountryValue)=>{
                if (newCountryValue !== lastCountryValue) {
                    shippingForm.fields.postalCode.validators = getPostalCodeValidators(newCountryValue);
                    lastCountryValue = newCountryValue;
                    const fieldsToReset = [
                        shippingForm.fields.region,
                        shippingForm.fields.city,
                        shippingForm.fields.street1,
                        shippingForm.fields.street2,
                        shippingForm.fields.postalCode
                    ];
                    fieldsToReset.forEach((field)=>field.set(""));
                }
            });
            // save values to local storage
            if (useLocalStorage) {
                shippingForm.on("change", ()=>{
                    const values = shippingForm.getValues();
                    local_storage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z.setItem(helpers__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.localStorageNames.shippingFormValues, values);
                });
            }
        }
        return shippingForm;
    }, [
        useLocalStorage,
        isAttentivePhonePermissionsEnabled
    ]);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useShippingForm);


/***/ })

}]);